import { FC } from 'react';
import styled from 'styled-components';
import CommonWrapper from '../ui_components/CommonComponentsStructureCss';

const Container = styled.div`
  .text-center {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }
`;

const LoadingState: FC = () => {
  return (
    // Absolute a tutto il foglio
    <CommonWrapper className='loading-state'>
      <Container className="container">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </Container>
    </CommonWrapper>
  );
};

interface ErrorStateProps {
  error: string;
}

const ErrorState: FC<ErrorStateProps> = ({ error }) => {
  return (
    <CommonWrapper className='error-state'>
      <Container className="container">
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </Container>
    </CommonWrapper>
  );
};

export { LoadingState, ErrorState };
